import { jsx } from 'react/jsx-runtime';
import { useRef, useMemo } from 'react';
import '@dynamic-labs/multi-wallet';
import '@dynamic-labs/sdk-api';
import '../../../../config/ApiEndpoint.js';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '../../../../context/ViewContext/ViewContext.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import '../../../../context/DynamicContext/DynamicContext.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import { useResizeObserver } from '../../../../utils/hooks/useResizeObserver/useResizeObserver.js';
import { useTransition } from '../../../../utils/hooks/useTransition/useTransition.js';
import 'react-dom';
import '../../../ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-focus-lock';
import '../../../Transition/ZoomTransition/ZoomTransition.js';
import '../../../Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../Transition/OpacityTransition/OpacityTransition.js';
import '../../../IconButton/IconButton.js';
import 'ethers';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';

const IN_DURATION = 150;
const OUT_DURATION = 150;
const VerticalDrawerAnimation = ({ isPresent, onAnimationEnd, children, inDuration = IN_DURATION, outDuration = OUT_DURATION, style, }) => {
    const containerRef = useRef(null);
    const childRef = useRef(null);
    const [childEntry] = useResizeObserver(childRef);
    const containerChildHeight = useMemo(() => childEntry === null || childEntry === void 0 ? void 0 : childEntry.height, [childEntry]);
    const { mount, stage, currentDuration } = useTransition({
        animateOnMount: false,
        inDuration,
        isShown: isPresent,
        onUnmount: onAnimationEnd,
        outDuration,
    });
    const maxHeight = useMemo(() => {
        if (!mount || stage === 'EXITING' || stage === 'UNMOUNT') {
            return 0;
        }
        return containerChildHeight;
    }, [stage, containerChildHeight, mount]);
    return (jsx("div", Object.assign({ ref: containerRef, className: 'vertical-drawer-animation', style: Object.assign(Object.assign({}, style), { maxHeight, transitionDuration: `${currentDuration}ms` }) }, { children: jsx("div", Object.assign({ ref: childRef }, { children: mount && children })) })));
};

export { IN_DURATION, OUT_DURATION, VerticalDrawerAnimation };
